import { CurrentUserAvatar } from './CurrentUserAvatar';
import React from 'react';
import { useAuthToken } from '@hooks';

import { administrationMenuItem, helpMenuItem, logoutMenuItem, settingsMenuItem, termsMenuItem } from './menuitems';
import { Dropdown, Space } from 'antd';
import { SonarMenu, SonarMenuItem } from '@ui/menu';

const menuItems: Array<SonarMenuItem> = [
	administrationMenuItem,
	settingsMenuItem,
	helpMenuItem,
	termsMenuItem,
	logoutMenuItem
];

export const UserMenu: React.FC = () => {
	const { isAdmin } = useAuthToken();

	const menu = <SonarMenu
		id='user-menu'
		items={ isAdmin ? menuItems : menuItems.slice(1) } />;

	return (
		<Dropdown
			popupRender={ () => menu }
			trigger={ [ 'click' ] }>
			<Space>
				<CurrentUserAvatar />
			</Space>
		</Dropdown>
	);
};
